module.exports = __webpack_public_path__ + "static/media/bookPile.facef468.jpeg";